import { render, staticRenderFns } from "./commission-date.component.vue?vue&type=template&id=77516418&"
import script from "./commission-date.component.vue?vue&type=script&lang=ts&"
export * from "./commission-date.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports